const APP_ID = '2021002134619557';
// const APP_ID = '2021003129689318';
export default {
    getAuthCode() {
        return new Promise((resolve, reject) => {
            window.ap.getAuthCode({
                appId: APP_ID,
                scopes: ['auth_user'],
                showErrorTip: false,
            }, (res) => {
                if (res.error > 0) {
                    reject(res);
                } else {
                    resolve(res.authCode);
                }
            });
        });
    },
    pay(tradeNO) {
        return new Promise((resolve, reject) => {
            window.ap.tradePay({
                tradeNO,
            }, (res) => {
                if (res.resultCode === '9000') {
                    resolve();
                } else {
                    reject(res);
                }
            });
        });
    },
};
